import React from 'react';
import { useTheme } from '../theme/ThemeContext';

export default function BrandLogo({ size = 36 }: { size?: number }) {
    const { isDark } = useTheme();

    return (
        <div className="flex items-center gap-3">
            <div
                className="flex items-center justify-center overflow-hidden rounded-xl bg-brand-primary"
                style={{ width: size, height: size }}
            >
                {/* Switch logo based on theme */}
                <img
                    src={isDark ? "/logo-original.png" : "/logo-transparent.png"}
                    alt="LesslyKilo Logo"
                    className="h-full w-full object-contain p-1.5"
                />
            </div>
            <span className="text-lg font-black tracking-tight md:text-xl text-brand-text">
                LesslyKilo
              </span>
        </div>
    );
}